import { appTheme } from "./constants";

export const getAppTheme = () => {
  const theme = localStorage.getItem(appTheme);
  return theme;
};
